import { render, staticRenderFns } from "./coagency.vue?vue&type=template&id=5277a360&scoped=true&"
import script from "./coagency.vue?vue&type=script&lang=js&"
export * from "./coagency.vue?vue&type=script&lang=js&"
import style0 from "./coagency.vue?vue&type=style&index=0&id=5277a360&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5277a360",
  null
  
)

export default component.exports